import { Component, OnInit } from '@angular/core';
import { ProyectoService } from 'src/app/services/proyecto.service';
import { Recibo } from 'src/app/models/comprobante.model';
import { ActivatedRoute } from '@angular/router';
import { PagosService } from 'src/app/services/pagos.service';
import { CriptoService } from 'src/app/services/cripto.service';
import { FormGroup } from '@angular/forms';
import Swal from 'sweetalert2';

interface Producto {
  idProducto: number;
  descripcion: string;
  precioSocio: number;
  precioPublico: number;
  precioEstudiante: number;
  esActivo: boolean;
  vigencia: string;
}

@Component({
  selector: 'app-factura',
  templateUrl: './factura.component.html',
  styleUrls: ['./factura.component.scss']
})
export class FacturaComponent implements OnInit {

  conceptos: Producto[] = [];
  selectedConcepto: number | null = null;
  selectedPrecio: string = '';
  isCurso: boolean = false;
  conceptoSeleccionado: Producto | null = null;
  public idSocioDesencriptado: string;
  public productos: any[] = [];
  public productosTemp: any[] = [];
  public infoPagoForm: FormGroup;
  public loading: boolean = false;
  public seleccionarConceptoForm: FormGroup;
  public isPagoCurso: boolean;
  public userTypeId: number;
  public seleccionarPrecio: boolean;

  constructor(
    private proyectoservice: ProyectoService,
    private route: ActivatedRoute,
    private _pagosService: PagosService,
    private _criptoService: CriptoService,
    private _route: ActivatedRoute,

  ) {
    this.idSocioDesencriptado = this._criptoService.decrypt(localStorage.getItem('idSocio'));
    this.userTypeId = this._criptoService.decrypt(localStorage.getItem('userTypeId'));

  }

  ngOnInit(): void {
    this.loading = true;

    this.route.params.subscribe(params => {
      const idCotizacion = +params['idCotizacion'];
      console.log('ID Cotización:', idCotizacion); // Imprime el ID de cotización en la consola
      this.getProductosActivos();
    });
  }

  getProductosActivos() {


    console.log("id ", !Number(this.idSocioDesencriptado))
    if (!Number(this.idSocioDesencriptado)) {
      console.log("No hay idSocio")
      this._route.params.subscribe(params => {

        const productosList = [
          {
              idProducto: 160,
              idTipoEvento: 3,
              tipo: "Evento",
              codigo: "AAA-0",
              descripcion: "Boleto Colegiados y estudiantes",
              precioSocio: 300,
              precioPublico: 0,
              precioEstudiante: 0,
              esActivo: true,
              vigencia: "2024-10-13T00:00:00",
              satUnidad: "0",
              satClave: "0",
              satieps: 0,
              sativa: 0,
              sativaRet: 0
          },
          {
            idProducto: 161,
            idTipoEvento: 3,
            tipo: "Evento",
            codigo: "AAA-0",
            descripcion: "Boleto Público General",
            precioSocio: 0,
            precioPublico: 350,
            precioEstudiante: 0,
            esActivo: true,
            vigencia: "2024-10-13T00:00:00",
            satUnidad: "0",
            satClave: "0",
            satieps: 0,
            sativa: 0,
            sativaRet: 0
        },
        {
          idProducto: 162,
          idTipoEvento: 3,
          tipo: "Evento",
          codigo: "AAA-0",
          descripcion: "Boleto Caminata recreativa",
          precioSocio: 250,
          precioPublico: 0,
          precioEstudiante: 0,
          esActivo: true,
          vigencia: "2024-10-13T00:00:00",
          satUnidad: "0",
          satClave: "0",
          satieps: 0,
          sativa: 0,
          sativaRet: 0
      }
      ].filter(p => p.idProducto === +params.idProducto)
  
  
        this.productos = [...productosList];
        this.productosTemp = [...productosList];

        console.log("this.productosTemp: ", this.productosTemp);
      });

      this.infoPagoForm.get("nombreTitular").enable();
    }

    this._pagosService.getProductosActivos(this.idSocioDesencriptado).subscribe(
      response => {
        console.log(response);
        this.productos = response.data;
        this.productosTemp = this.productos;
        this.loading = false;

        //Obtiene el parámetro de la URL para settear el valor al select de 'Seleccione un Concepto'
        this._route.params.subscribe(params => {
          console.log('params ', params);
          //Si hay idProducto por la URL
          if (+params.idProducto != null) {
            //Filtra sólo el producto en base al 'idProducto' que llegue en la URL
            this.productos = this.productos.filter(prod => prod.idProducto == +params.idProducto);
            //Asigna el 'idProducto' que viene de la URL al select 'Concepto' para que aparezca seleccionado el producto
            console.log("Pruebita 1: ", this.productos);
            this.seleccionarConceptoForm.setValue({
              concepto: params.idProducto,
              precio: this.productos[0].precioPublico
            });
          }

          //Verifica si en el url viene algún parámetro tipo query
          this._route.queryParams.subscribe(
            params => {

              console.log("Pruebita 2: ", params.id);

              //Si existe el parámetro 'curso' en la URL
              if (params.curso) {
                //'this.isPagoCurso' se marca como verdadero para mostrar una vista diferente
                this.isPagoCurso = true;
              }
              else {
                //'this.isPagoCurso' se marca como falso para mostrar una vista diferente
                this.isPagoCurso = false;
                //GOAT checar si el parametro idProducto esta vacio, si no, tomo el id y lo selecciono en el
                //dropdown
              }
            }
          );


          //Si el userTypeId es igual a 5 (Externo)
          if (this.userTypeId == 5) {
            this.seleccionarPrecio = true;

            //Sólo selecciona el concepto del producto para que aparezca seleccionado sin el precio
            this.seleccionarConceptoForm.setValue({
              concepto: params.idProducto,
              precio: ''
            });
          }
        });
      },
      error => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  onConceptoChange(): void {
    if (this.selectedConcepto != null) {
        // Encuentra el concepto seleccionado de la lista de productos
        this.conceptoSeleccionado = this.productos.find(c => c.idProducto === this.selectedConcepto) || null;
        console.log('Concepto seleccionado:', this.conceptoSeleccionado); // Verifica el valor de conceptoSeleccionado
        if (this.conceptoSeleccionado) {
            // Limpia la selección del precio cuando cambia el concepto
            this.selectedPrecio = '';
        }
    }
}



  onUploadClick(): void {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = '.png, .jpeg'; // Limita la selección a archivos PNG y JPEG

    fileInput.onchange = () => {
      const file = fileInput.files?.[0];
      if (file) {
        this.handleFileUpload(file);
      }
    };

    fileInput.click(); // Abre el explorador de archivos
  }

  handleFileUpload(file: File): void {
    // Verifica que el tamaño del archivo no supere los 1000 KB
    const maxFileSizeKB = 1000;
    if (file.size > maxFileSizeKB * 1024) {
      Swal.fire('Error', 'El archivo no debe superar los 1000 KB.', 'error');
      return;
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    
    reader.onload = () => {
      const base64String = reader.result?.toString().split(',')[1];

      if (base64String) {
        const split = file.name.split('.');
        const ext = split[split.length - 1];
        const simpleName = file.name.substring(0, file.name.length - (ext.length + 1));

        const request: Recibo = {
          fileContentBase64: base64String,
          fileName: simpleName,
          fileExt: ext,
          fileSize: file.size,
          idCotizacion: +this.route.snapshot.params['idCotizacion'], // Obtener el idCotizacion directamente
        };

        this.postComprobante(request);
      }
    };

    reader.onerror = (error) => {
      console.error

('Error al leer el archivo:', error);
    };
  }

  postComprobante(request: Recibo): void {
    this.proyectoservice.postComprobante(request)
      .subscribe(
        (response) => {
          console.log('Archivo subido exitosamente:', response);
          Swal.fire('Éxito', 'El comprobante se subió con éxito.', 'success');
        },
        (error) => {
          console.error('Error al subir el archivo:', error);
          Swal.fire('Error', 'Fallo al subir el comprobante.', 'error');
        }
      );
  }
}
